export enum SignUpState {
  SIGN_UP = 'SIGN_UP',
  CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP',
  DONE = 'DONE'
}
